module.exports = __webpack_public_path__ + "media/images/shinagawa-diagnostics-logo-980f8b8484a4e3473d7f77ba335e94cb.webp";